import { render } from "./CreateVote.vue?vue&type=template&id=4689e3e8&ts=true"
import script from "./CreateVote.vue?vue&type=script&lang=ts"
export * from "./CreateVote.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__